module.exports = __webpack_public_path__ + "img/users_grey_icon.bccaced1.svg";